import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2019-12-27 10:23:56
 * @LastEditTime: 2020-12-09 16:41:26
 */

/**
	@author marsboyding
	@class milo
	@descriptiton: milo入口，包括工具类(cookie操作、浏览器判断、安全、登录态同步等)/不包括加载器，加载器在milo_web中
*/
import ams from './ams';
import * as base from './base';
import platform from './platform';
import cookie from './cookie';
import event from './event';
import loader from './loader';
import loginStatus from './loginStatus';
import network from './network';
import object from './object';
import url from './url';
import xss from './xss';
import util from './util';
import MiloInit from './MiloInit'; // 立即执行

MiloInit["do"]();

var _Milo = _objectSpread(_objectSpread(_objectSpread({}, base), {}, {
  loader: loader,
  platform: platform,
  event: event
}, url), {}, {
  ams: ams,
  xss: xss,
  cookie: cookie,
  loginStatus: loginStatus,
  network: network,
  object: object,
  util: util,
  MiloInit: MiloInit
}); // 输出到全局，供插件调用


export default _Milo;